<div class="mb-5">
	<app-daily-utilization-chart
		[chart]="chart"
		[devicesType]="devicesType"
		[hasTruckTypeFilter]="false"
		[hasVoltageFilter]="true"
		[hasCapacityFilter]="true"
		[title]="'utilization.daily_battery_fleet_utilization_title' | translate"
		[tooltipText]="'battlinkDevice.daily_fleet_utilization'"
		[fromDate]="fromDate"
		[toDate]="toDate"
		[selectedBatteryVoltage]="selectedBatteryVoltage"
		[selectedBatteryCapacity]="selectedBatteryCapacity"
		[selectedBatteryVintage]="selectedBatteryVintage"
		[selectedTruckManufacturer]="selectedManufacturer"
		[userParentFilters]="true"
		[vAxisTitle]="'site.number_of_batteries' | translate"
		(prepareParentFiltersOptions)="prepareParentFiltersOptionsEmitter($event)"
	></app-daily-utilization-chart>
</div>
